import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
export function extractHeadersFromAxiosResponse(response) {
  var headers = [];

  for (var _i = 0, _Object$keys = Object.keys(response.headers); _i < _Object$keys.length; _i++) {
    var headerKey = _Object$keys[_i];
    headers.push({
      header: headerKey,
      value: response.headers[headerKey]
    });
  }

  return headers;
}